export function sendStats(params: string, searchParams?: Record<string, string>, headers?: Record<string, string>) {
	const totalSearchParams = new URLSearchParams({
		...searchParams,
		ts: new Date().getTime().toString(),
	});
	fetch(`/stats/${params}?${totalSearchParams}`, {headers});
}
